export default "/images/framework/WowBarEng.762495eb.svg?762495eb";